import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
import Button from 'flarum/common/components/Button';
import Separator from 'flarum/common/components/Separator';
import ItemList from 'flarum/common/utils/ItemList';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import listItems from 'flarum/common/helpers/listItems';
import username from 'flarum/common/helpers/username';
import humanTime from 'flarum/common/utils/humanTime';
import formatNumber from 'flarum/common/utils/formatNumber';

// Tag links belong in the in-page navigation of a tag page, not in the global sidebar.
const TAG_ITEM = /^(tag\d+|moreTags|separator)$/;

/**
 * The `PxSidebar` component is the fixed left column: a pixel-framed user card
 * (or a welcome card for guests), a "Play PixMMO" button, the forum navigation
 * and the session links.
 */
export default class PxSidebar extends Component {
  view() {
    return m("div", {
      className: "PxSidebar-container"
    }, m("div", {
      className: "PxSidebar-user"
    }, app.session.user ? this.userView(app.session.user) : this.guestView()), this.playButton(), m("nav", {
      className: "PxSidebar-nav"
    }, m("ul", null, listItems(this.items().toArray()))));
  }
  userView(user) {
    return m("div", {
      className: "PxSidebar-loggedIn"
    }, m("div", {
      className: "PxSidebar-avatar"
    }, m(Avatar, {
      user: user
    }), m("ul", {
      className: "badges"
    }, listItems(user.badges().toArray()))), m("h4", {
      className: "PxSidebar-username"
    }, username(user)), m("p", {
      className: "PxSidebar-joined"
    }, app.translator.trans('core.forum.user.joined_date_text', {
      ago: humanTime(user.joinTime())
    })), m("div", {
      className: "PxSidebar-stats"
    }, m("div", {
      className: "PxSidebar-stat"
    }, m("span", null, app.translator.trans('core.forum.user.posts_link')), m("span", null, formatNumber(user.commentCount() || 0))), m("div", {
      className: "PxSidebar-stat"
    }, m("span", null, app.translator.trans('core.forum.user.discussions_link')), m("span", null, formatNumber(user.discussionCount() || 0)))));
  }
  guestView() {
    return m("div", {
      className: "PxSidebar-guest"
    }, m("h4", null, app.translator.trans('soup-97-pixmmo-pixelui.forum.welcome_title')), m("p", null, app.translator.trans('soup-97-pixmmo-pixelui.forum.welcome_text')), m("div", {
      className: "PxSidebar-guestButtons"
    }, this.guestButtons().toArray()));
  }
  guestButtons() {
    const items = new ItemList();
    if (app.forum.attribute('allowSignUp')) {
      items.add('signUp', m(Button, {
        className: "Button Button--primary Button--block",
        onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'))
      }, app.translator.trans('core.forum.header.sign_up_link')), 20);
    }
    items.add('logIn', m(Button, {
      className: "Button Button--block",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
    }, app.translator.trans('core.forum.header.log_in_link')), 10);
    return items;
  }
  playButton() {
    const url = app.forum.attribute('pxGameUrl');
    if (!url) return null;
    return m("div", {
      className: "PxSidebar-play"
    }, m("a", {
      className: "Button Button--primary Button--block PxSidebar-playButton",
      href: url,
      target: "_blank",
      rel: "noopener"
    }, m("i", {
      className: "icon fas fa-gamepad Button-icon",
      "aria-hidden": "true"
    }), m("span", {
      className: "Button-label"
    }, app.translator.trans('soup-97-pixmmo-pixelui.forum.play_button'))));
  }

  /**
   * The navigation list: the index page's nav items (minus individual tags),
   * followed by the session dropdown's items for logged-in users. Reusing both
   * lists means links added by other extensions show up here too.
   */
  items() {
    const items = new ItemList();
    const nav = new IndexSidebar().navItems();
    for (const key of Object.keys(nav.toObject())) {
      if (!TAG_ITEM.test(key)) items.add(key, nav.get(key), 100 + nav.getPriority(key));
    }
    if (app.session.user) {
      items.add('px-separator', m(Separator, null), 0);
      const session = SessionDropdown.prototype.items.call(new SessionDropdown());
      for (const key of Object.keys(session.toObject())) {
        if (key !== 'separator') items.add('session-' + key, session.get(key), session.getPriority(key) - 200);
      }
    }
    return items;
  }
}
flarum.reg.add('soup-97-pixmmo-pixelui', 'forum/components/PxSidebar', PxSidebar);